module.exports = __webpack_public_path__ + "img/banner3.053f058a.jpg";